export const LOGGED_IN_CHECK = "LOGGED_IN_CHECK";

export const POP_UP_CONTROL = "POP_UP_CONTROL";

export const CREATE_POST_SUCCESS = "CREATE_POST_SUCCESS"; // C
export const GET_POSTS_SUCCESS = "GET_POSTS_SUCCESS"; // R
export const UPDATE_POST_SUCCESS = "UPDATE_POST_SUCCESS"; // U
export const DELETE_POST_SUCCESS = "DELETE_POST_SUCCESS"; // D

export const GET_USER_POSTS_SUCCESS = "GET_USER_POSTS_SUCCESS"